export default "__VITE_ASSET__ClPzSfAT__ 584w";